import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';

function RemainingBalanceInfoComponent({ value }) {
  return (
    <Typography
      component="div"
      sx={{ backgroundColor: '#FCFAFA', padding: '8px' }}
      variant="caption"
    >
      O saldo de&nbsp;
      {value || <Box component="span">-</Box>}
      &nbsp;pode ser parcelado em até {process.env.DAYS_BEFORE_BOOKING} dias
      antes do embarque no boleto ou no cartão de crédito.
    </Typography>
  );
}

RemainingBalanceInfoComponent.propTypes = {
  value: PropTypes.node.isRequired,
};

export default RemainingBalanceInfoComponent;
